import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { ProjectIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { listRoute } from '@atlassian/jira-router-routes-servicedesk-list-routes/src/listRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { listEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-list/entrypoint.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { horizontalNavViewEntrypoint } from '@atlassian/jira-horizontal-nav-jsm-views/entrypoint.tsx';
import { uifBoardResource } from '@atlassian/jira-router-resources-uif-board/src/index.tsx';

const entryPoint = createPageEntryPoint({
	main: listEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: horizontalNavViewEntrypoint,
});

export const listRouteEntry = createEntry(listRoute, () => ({
	group: 'servicedesk',
	component: ErrorPagesNotFound,
	layout: serviceProjectLayout,
	entryPoint: () => {
		if (!fg('jsm_list_view_milestone_1')) {
			return undefined;
		}
		return entryPoint;
	},
	skeleton: ProjectIssueNavigatorSkeleton,
	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
	},
	forPaint: [LazyAtlassianNavigation],
	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
		projectContextResource,
		uifBoardResource,
	],

	supportsPreviewPanel: true,
}));
